// Single source of truth for the sync dimensions used across the BigCommerce
// ops console. `market` (AU/NZ) drives Akeneo/Epicor source data; `environment`
// (prod/staging) selects which BigCommerce store the sync targets. The pair
// (environment, market) identifies a BigCommerce store and a worker process.

export const MARKETS = ['AU', 'NZ'];

export const ENVIRONMENTS = ['prod', 'staging'];

export const DEFAULT_ENVIRONMENT = 'prod';

export const ENVIRONMENT_LABELS = {
  prod: 'Production',
  staging: 'Staging',
};

// Composite key matching the backend worker-health response
// (backend/sync_router.py workers_health) and worker heartbeat PK.
export const workerKey = (environment, marketCode) => `${environment}:${marketCode}`;

// The four sync targets surfaced by the Manual Syncs page. `id` uses the same
// `${environment}:${market}` composite as workerKey so a target maps 1:1 to a
// worker process and a BigCommerce store.
export const SYNC_TARGETS = [
  { id: 'prod:AU', environment: 'prod', market: 'AU', label: 'AU Production' },
  { id: 'prod:NZ', environment: 'prod', market: 'NZ', label: 'NZ Production' },
  { id: 'staging:AU', environment: 'staging', market: 'AU', label: 'AU Staging' },
  { id: 'staging:NZ', environment: 'staging', market: 'NZ', label: 'NZ Staging' },
];

export const DEFAULT_SYNC_TARGET = 'staging:AU';
